var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ActionsBlockContainer, CommentItemContainer, CommentPostContainer, DeletedMsg, ImagesWrapper, InfoAvatar, InfoName, InfoTime, LikesCount, NewCommentContainer, PostContentContainer, TooltipWrapper } from "../../styles";
import { Avatar, FlexBox, Skeleton } from "@brg/ui";
import { bProfile, ProfileUtils, useAuth, useProfile } from "@brg/auth";
import { useDispatch, useSelector } from "react-redux";
import { API, LikeObject, Nullable, PageModel } from "@brg/api";
import { useTheme } from "styled-components";
import useLocalization from "../../../../../hooks/useLocalization";
import { useModal } from "../../../../../core/modules/modal.module";
import { formatDate } from "../support/formatDate";
import { COMMENT_EDIT_MODE, POST_STATUS, SUB_COMMENT_OFFSET } from "../../const/const";
import { fetchMoreTreeComments, onUpdateChatState, updateCommentStatus } from "../../../../../actions/chatActions";
import { CommentEdit } from "../edit/CommentEdit";
import TextWithLinks from "../support/textWithLinks";
import { LoaderSpinner } from "../support/LoaderSpinner";
import { ClickOutsideComponent } from "../support/ClickOutsideComponent";
import { computeDesigner } from "../support/ComputeDesigner";
import { CommentImages } from "./CommentImages";
import { CommentTools } from "./CommentTools";
import { LikesComponent, LikesCountText } from "./LikesComponent";
import useCommonProps from "../../../../../hooks/useCommonProps";
import { transformByLang } from "../support/transformByLang";
import { CommentCount } from "../../assets/CommentCount";
var CommentInfo = function (_a) {
    var created = _a.created, account = _a.account, accountId = _a.accountId, parentId = _a.parentId, id = _a.id, edited = _a.edited, text = _a.text, attachments = _a.attachments, tooltipProps = _a.tooltipProps, handlers = __rest(_a, ["created", "account", "accountId", "parentId", "id", "edited", "text", "attachments", "tooltipProps"]);
    var profile = useProfile();
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var hasEdited = useMemo(function () {
        var _a, _b;
        return ((_a = new Date(created !== null && created !== void 0 ? created : '')) === null || _a === void 0 ? void 0 : _a.getTime()) !== ((_b = new Date(edited !== null && edited !== void 0 ? edited : '')) === null || _b === void 0 ? void 0 : _b.getTime());
    }, [created, edited]);
    var computeAccount = useMemo(function () {
        return API.toLang(account, language);
    }, [account, language]);
    return (React.createElement(CommentPostContainer, null,
        React.createElement(FlexBox, { direction: "column" },
            React.createElement(FlexBox, { width: '100%' },
                React.createElement(InfoAvatar, { href: window.location.origin + "/designer/".concat(accountId), target: "_blank" }, account && (React.createElement(Avatar
                // {...account} 
                , { 
                    // {...account} 
                    avatar: ProfileUtils.getAvatarURLOrUndefined(account), fs: 11, rounded: true }))),
                React.createElement(FlexBox, { gy: 6, direction: "column", directionMobile: "column" },
                    React.createElement(InfoTime, null,
                        formatDate(created !== null && created !== void 0 ? created : '', language),
                        "\u00A0",
                        hasEdited ? t('chat.post.edited') : ''),
                    React.createElement(InfoName, { href: window.location.origin + "/designer/".concat(accountId), target: "_blank" }, ProfileUtils.getFullNameString(computeAccount))))),
        profile && !tooltipProps.isChatClosed && (React.createElement(TooltipWrapper, null,
            React.createElement(CommentTools, __assign({ isEditable: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.isEditable(accountId), isDeletable: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.isDeletable(accountId), canAnswer: (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.canAnswer(accountId)) && !parentId, canReport: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.canReport(accountId), isBlackList: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.isBlackList, isWhiteList: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.isWhiteList, isPrivateChat: tooltipProps.isPrivateChat, isChatClosed: tooltipProps.isChatClosed, identifier: id }, handlers))))));
};
var CommentContent = function (_a) {
    var _b, _c;
    var post = _a.post;
    var t = useLocalization().t;
    if (post.status === POST_STATUS.deleted) {
        return React.createElement(DeletedMsg, null, t('chat.post.deleted'));
    }
    return (React.createElement(FlexBox, { direction: "column" },
        React.createElement(PostContentContainer, null,
            React.createElement(TextWithLinks, { text: post.text })),
        !!((_b = post === null || post === void 0 ? void 0 : post.attachments) === null || _b === void 0 ? void 0 : _b.length) && (React.createElement(ImagesWrapper, null,
            React.createElement(React.Fragment, null, (_c = post === null || post === void 0 ? void 0 : post.attachments) === null || _c === void 0 ? void 0 : _c.map(function (image) { return (React.createElement(CommentImages, { attachment: image, key: image.attachmentId })); }))))));
};
var CommentActions = function (_a) {
    var post = _a.post, tooltipProps = _a.tooltipProps, isLiked = _a.isLiked, likeCount = _a.likeCount, isEditing = _a.isEditing, handlers = _a.handlers;
    var t = useLocalization().t;
    var theme = useTheme();
    var currentId = useMemo(function () {
        return !!(post === null || post === void 0 ? void 0 : post.parentId) ? post.parentId : post.id;
    }, [post]);
    var canAnswer = useMemo(function () {
        return !!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.canAnswer(post.accountId)) && !(post === null || post === void 0 ? void 0 : post.parentId);
    }, [post, tooltipProps, isEditing]);
    if (post.status === POST_STATUS.deleted)
        return null;
    return (React.createElement(ActionsBlockContainer, { gx: 24 },
        React.createElement(LikesComponent, { isLiked: isLiked, disabled: !(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.canLike(post.accountId)), onLikeClick: function () {
                var _a;
                (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onLike) === null || _a === void 0 ? void 0 : _a.call(handlers, {
                    entityId: post.entityId,
                    entityType: post.entityType
                });
            } }),
        React.createElement(LikesCount, null, likeCount),
        canAnswer && (React.createElement("span", { onClick: function () {
                var _a;
                (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onAnswer) === null || _a === void 0 ? void 0 : _a.call(handlers, currentId !== null && currentId !== void 0 ? currentId : '');
            } }, t('chat.post.answer')))));
};
var Comment = function (_a) {
    var _b;
    var comment = _a.comment, tooltipProps = _a.tooltipProps, creatingId = _a.creatingId, handlers = _a.handlers, entityId = _a.entityId, postEntityId = _a.postEntityId;
    var t = useLocalization().t;
    var dispatch = useDispatch();
    var modal = useModal();
    var profile = useProfile();
    var newCommentRef = useRef(null);
    var auth = useAuth();
    var _c = useState(POST_STATUS.active), isDeleted = _c[0], setIsDeleted = _c[1];
    var _d = useState(false), isLiked = _d[0], setIsLiked = _d[1];
    var _e = useState(0), likeCount = _e[0], setLikeCount = _e[1];
    var _f = useState(null), isEditing = _f[0], setIsEditing = _f[1];
    useEffect(function () {
        setIsDeleted(comment.status);
        setIsLiked(comment.isQu);
        setLikeCount(comment.quCount || 0);
    }, [comment]);
    var handleClickOutside = function (event) {
        if (newCommentRef.current && !newCommentRef.current.contains(event.target)) {
            setIsEditing(null);
        }
    };
    useEffect(function () {
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    var getLocalHandlers = useCallback(function (comment) {
        return __assign(__assign({}, handlers), { onDelete: function (postId) {
                modal.show('templateModal', {
                    mainText: t('chat.modal.delete_title'),
                    confirmText: t('chat.modal.confirm_delete'),
                    secondText: t('chat.modal.delete_subtitle'),
                    cancelText: t('chat.modal.cancel'),
                    onConfirm: function () {
                        var _a;
                        handlers.onDelete((_a = (postId)) !== null && _a !== void 0 ? _a : '')
                            .then(function (response) {
                            if (response) {
                                setIsDeleted(POST_STATUS.deleted);
                                dispatch(updateCommentStatus({
                                    postEntityId: postEntityId,
                                    commentId: postId,
                                    parentId: comment === null || comment === void 0 ? void 0 : comment.parentId
                                }));
                                modal.hide();
                            }
                        });
                    },
                    onSecond: function () {
                        modal.hide();
                    }
                });
            }, onEdit: function (postId) {
                var _a;
                dispatch(onUpdateChatState({
                    answerId: postId,
                    imageMode: (comment === null || comment === void 0 ? void 0 : comment.attachments) && ((_a = comment === null || comment === void 0 ? void 0 : comment.attachments) === null || _a === void 0 ? void 0 : _a.length) > 0
                }));
                setIsEditing(COMMENT_EDIT_MODE.edit);
            }, onLike: function () {
                var _a, _b;
                if (comment && tooltipProps.canLike(comment.accountId)) {
                    if (!profile) {
                        auth.login();
                        return;
                    }
                    (_a = handlers.onLike) === null || _a === void 0 ? void 0 : _a.call(handlers, {
                        entityId: (_b = comment.id) !== null && _b !== void 0 ? _b : '',
                        entityType: 'comment'
                    }).then(function (response) {
                        var like = response;
                        setIsLiked(like.isLike);
                        setLikeCount(!!like.isLike ? likeCount + 1 :
                            (likeCount - 1));
                    });
                }
            }, onAnswer: function (id) {
                if (!profile) {
                    auth.login();
                    return;
                }
                dispatch(onUpdateChatState({ answerId: id, scrollId: null }));
                setIsEditing(COMMENT_EDIT_MODE.answer);
            } });
    }, [handlers, dispatch, likeCount, isEditing, tooltipProps]);
    var onUpdate = function () {
        setIsEditing(null);
    };
    var isSubComment = useMemo(function () {
        return (comment === null || comment === void 0 ? void 0 : comment.parentId) !== null;
    }, [isEditing, comment]);
    var newComment = useMemo(function () {
        if (isEditing === COMMENT_EDIT_MODE.answer) {
            return (React.createElement(NewCommentContainer, { ref: newCommentRef, width: '100%', widthMobile: '100%', offsetBottom: 32, offsetBottomMobile: 32 },
                React.createElement(CommentEdit, { entityId: comment === null || comment === void 0 ? void 0 : comment.entityId, postEntityId: postEntityId, chatAllowedProps: tooltipProps, mode: COMMENT_EDIT_MODE.answer, onUpdate: onUpdate })));
        }
    }, [tooltipProps, entityId, newCommentRef, isEditing, comment]);
    if (isDeleted) {
        return React.createElement(DeletedMsg, null, t('chat.post.deleted'));
    }
    if ((_b = [COMMENT_EDIT_MODE.edit]) === null || _b === void 0 ? void 0 : _b.includes(isEditing)) {
        return (React.createElement(CommentEdit, { entityId: comment === null || comment === void 0 ? void 0 : comment.entityId, postEntityId: postEntityId, mode: COMMENT_EDIT_MODE.edit, comment: comment, onUpdate: onUpdate }));
    }
    if ((comment === null || comment === void 0 ? void 0 : comment.id) === creatingId) {
        return (React.createElement(CommentItemContainer, { subComment: isSubComment, "data-message-id": comment.id },
            React.createElement(LoaderSpinner, { color: "#909090", text: t('chat.post.loading_text') })));
    }
    return (React.createElement(CommentItemContainer, { subComment: isSubComment, "data-message-id": comment.id },
        React.createElement(FlexBox
        // {...(isSubComment ? {
        //   offsetLeft: 32,
        //   offsetLeftMobile: 32,
        // } : {})}
        , { 
            // {...(isSubComment ? {
            //   offsetLeft: 32,
            //   offsetLeftMobile: 32,
            // } : {})}
            style: __assign({ gap: 16 }, (isSubComment ? {
                paddingRight: 0
            } : {})), width: '100%', widthMobile: '100%', direction: "column", directionMobile: "column" },
            React.createElement(CommentInfo, __assign({}, comment, { tooltipProps: tooltipProps }, getLocalHandlers(comment))),
            React.createElement(CommentContent, __assign({ post: comment }, handlers)),
            React.createElement(CommentActions, { post: comment, isLiked: isLiked, likeCount: likeCount, isEditing: isEditing, tooltipProps: tooltipProps, handlers: getLocalHandlers(comment) })),
        newComment));
};
export var CommentLoad = function (_a) {
    var data = _a.data, parentId = _a.parentId, postEntityId = _a.postEntityId, creatingId = _a.creatingId, onLoad = _a.onLoad, tooltipProps = _a.tooltipProps, handlers = _a.handlers;
    var t = useLocalization().t;
    var comments = useMemo(function () { return (data === null || data === void 0 ? void 0 : data.data) || []; }, [data]);
    var paging = useMemo(function () { return (data === null || data === void 0 ? void 0 : data.paging) || undefined; }, [data]);
    var _b = useState(false), showMore = _b[0], setShowMore = _b[1];
    var isCommentCreating = useMemo(function () {
        return comments === null || comments === void 0 ? void 0 : comments.some(function (comment) { return (comment === null || comment === void 0 ? void 0 : comment.id) === creatingId; });
    }, [comments, creatingId]);
    useEffect(function () {
        //to-do раскрывать ответы при добавлении нового ответа
        if (isCommentCreating) {
            setShowMore(true);
        }
    }, [isCommentCreating]);
    var needLoad = useMemo(
    //@ts-ignore
    function () { return (paging && (paging === null || paging === void 0 ? void 0 : paging.count) > SUB_COMMENT_OFFSET); }, [paging]);
    var isEndComment = useMemo(function () {
        return showMore && (comments === null || comments === void 0 ? void 0 : comments.length) === (paging === null || paging === void 0 ? void 0 : paging.count);
    }, [comments, paging, showMore]);
    var loadButton = useMemo(function () {
        if (isCommentCreating) {
            return React.createElement(Skeleton, { height: 20, width: 80 });
        }
        if (isEndComment) {
            return (React.createElement(CommentCount, { fs: 15, lh: 20, text: t('chat.hide_comments'), onClick: function () { return setShowMore(false); } }));
        }
        if (!needLoad)
            return;
        return (React.createElement(InfoTime, { onClick: onLoad, largeSize: true, style: { cursor: 'pointer', marginTop: 24 } }, t('chat.more')));
    }, [needLoad, paging, onLoad, showMore, , isCommentCreating, isEndComment]);
    var showAnswerButton = useMemo(function () {
        if ((paging === null || paging === void 0 ? void 0 : paging.count) === 0)
            return null;
        return (React.createElement(CommentCount, { count: paging === null || paging === void 0 ? void 0 : paging.count, text: t('chat.show_answers'), rotate: true, fs: 15, lg: 17, onClick: function () { return setShowMore(true); } }));
    }, [comments, paging]);
    if (paging.count > 0 && !showMore) {
        return showAnswerButton;
    }
    return (React.createElement(FlexBox, { gy: 32, gyMobile: 32, offsetLeft: 32, direction: "column", directionMobile: "column" }, comments === null || comments === void 0 ? void 0 :
        comments.map(function (post) {
            var _a;
            return (React.createElement("div", { key: (_a = post.id) !== null && _a !== void 0 ? _a : '' },
                React.createElement(Comment, { comment: post, tooltipProps: tooltipProps, handlers: handlers, creatingId: creatingId, postEntityId: postEntityId })));
        }),
        loadButton));
};
var CommentPost = function (_a) {
    var entityId = _a.entityId, comment = _a.comment, creatingId = _a.creatingId, order = _a.order, postHidden = _a.postHidden, handlers = _a.handlers, postEntityId = _a.postEntityId, tooltipProps = _a.tooltipProps;
    var comments = comment.comments, commentsCount = comment.commentsCount, loading = comment.loading;
    var profile = useProfile();
    var dispatch = useDispatch();
    var isModer = useMemo(function () { return profile && (bProfile.isModer(profile)); }, [profile]);
    var channelOwner = tooltipProps.channelOwner, isBlackList = tooltipProps.isBlackList, isWhiteList = tooltipProps.isWhiteList, isPrivateChat = tooltipProps.isPrivateChat, isChatClosed = tooltipProps.isChatClosed, isChatPause = tooltipProps.isChatPause;
    var isChannelOwner = useMemo(function () {
        return (channelOwner === null || channelOwner === void 0 ? void 0 : channelOwner.accountId) === (profile === null || profile === void 0 ? void 0 : profile.accountId);
    }, [profile, tooltipProps, channelOwner]);
    var canAnswer = useCallback(function (ownerId) {
        if (isChatClosed || isChatPause || isBlackList)
            return false;
        else if (isPrivateChat && !isWhiteList)
            return false;
        return true;
    }, [
        profile,
        tooltipProps,
        isWhiteList,
        isChatClosed,
        isBlackList
    ]);
    var isEditable = useCallback(function (ownerId) {
        return ownerId === (profile === null || profile === void 0 ? void 0 : profile.accountId) && !tooltipProps.isChatClosed;
    }, [profile, tooltipProps]);
    var isDeletable = useCallback(function (ownerId) {
        return ownerId === (profile === null || profile === void 0 ? void 0 : profile.accountId) || isChannelOwner || isModer;
    }, [profile, tooltipProps]);
    var canReport = useCallback(function (ownerId) {
        return ownerId !== (profile === null || profile === void 0 ? void 0 : profile.accountId);
    }, [profile, tooltipProps]);
    var canLike = useCallback(function (ownerId) {
        if (isBlackList || isChatPause || isChatClosed || !profile)
            return false;
        else if (isPrivateChat && !isWhiteList)
            return false;
        return true;
    }, [
        profile,
        tooltipProps,
        isChatPause,
        isChatClosed,
        isWhiteList,
        isPrivateChat,
        isBlackList
    ]);
    var fetchMore = function () {
        var _a;
        if (comments && comment) {
            dispatch(fetchMoreTreeComments({
                entityId: comment.entityId,
                parentId: comment.id,
                entityType: comment.entityType,
                postEntityId: postEntityId,
                parentFilter: {
                    //@ts-ignore
                    page: ((_a = comments === null || comments === void 0 ? void 0 : comments.paging) === null || _a === void 0 ? void 0 : _a.page) + 1,
                    offset: (comments === null || comments === void 0 ? void 0 : comments.paging.offset) + SUB_COMMENT_OFFSET,
                    limit: SUB_COMMENT_OFFSET
                }
            }));
        }
    };
    var localTooltipProps = useMemo(function () {
        return __assign(__assign({}, tooltipProps), { canAnswer: canAnswer, canReport: canReport, canLike: canLike, isEditable: isEditable, isDeletable: isDeletable });
    }, [
        tooltipProps,
        canReport,
        canAnswer,
        canLike,
    ]);
    var postComments = useMemo(function () {
        var _a, _b;
        if (commentsCount === 0 || comment.status === POST_STATUS.deleted)
            return null;
        if ((_a = comments === null || comments === void 0 ? void 0 : comments.data) === null || _a === void 0 ? void 0 : _a.length) {
            return React.createElement(CommentLoad, { data: comments, postEntityId: postEntityId, onLoad: fetchMore, parentId: (_b = comment.id) !== null && _b !== void 0 ? _b : '', creatingId: creatingId, tooltipProps: localTooltipProps, handlers: handlers });
        }
        return null;
    }, [comments, handlers, creatingId, comment, postEntityId, commentsCount]);
    if (postHidden)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(CommentItemContainer, { isMainComment: true, "data-message-id": comment.id, className: 'comment-item-container' },
            React.createElement(Comment, { comment: comment, tooltipProps: localTooltipProps, postEntityId: postEntityId, handlers: handlers, creatingId: creatingId }),
            postComments)));
};
export default CommentPost;
//# sourceMappingURL=CommentPost.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ActionsBlockContainer, CommentItemContainer, CommentPostContainer, DeletedMsg, ImagesWrapper, InfoAvatar, InfoName, InfoTime, LikesCount, NewCommentContainer, PostContentContainer, TooltipWrapper } from "../../styles";
import { Avatar, FlexBox, Skeleton } from "@brg/ui";
import { bProfile, ProfileUtils, useAuth, useProfile } from "@brg/auth";
import { useDispatch, useSelector } from "react-redux";
import { API, LikeObject, Nullable, PageModel } from "@brg/api";
import { useTheme } from "styled-components";
import useLocalization from "../../../../../hooks/useLocalization";
import { useModal } from "../../../../../core/modules/modal.module";
import { formatDate } from "../support/formatDate";
import { COMMENT_EDIT_MODE, POST_STATUS, SUB_COMMENT_OFFSET } from "../../const/const";
import { fetchMoreTreeComments, onUpdateChatState, updateCommentStatus } from "../../../../../actions/chatActions";
import { CommentEdit } from "../edit/CommentEdit";
import TextWithLinks from "../support/textWithLinks";
import { LoaderSpinner } from "../support/LoaderSpinner";
import { ClickOutsideComponent } from "../support/ClickOutsideComponent";
import { computeDesigner } from "../support/ComputeDesigner";
import { CommentImages } from "./CommentImages";
import { CommentTools } from "./CommentTools";
import { LikesComponent, LikesCountText } from "./LikesComponent";
import useCommonProps from "../../../../../hooks/useCommonProps";
import { transformByLang } from "../support/transformByLang";
import { CommentCount } from "../../assets/CommentCount";
var CommentInfo = function (_a) {
    var created = _a.created, account = _a.account, accountId = _a.accountId, parentId = _a.parentId, id = _a.id, edited = _a.edited, text = _a.text, attachments = _a.attachments, tooltipProps = _a.tooltipProps, handlers = __rest(_a, ["created", "account", "accountId", "parentId", "id", "edited", "text", "attachments", "tooltipProps"]);
    var profile = useProfile();
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var hasEdited = useMemo(function () {
        var _a, _b;
        return ((_a = new Date(created !== null && created !== void 0 ? created : '')) === null || _a === void 0 ? void 0 : _a.getTime()) !== ((_b = new Date(edited !== null && edited !== void 0 ? edited : '')) === null || _b === void 0 ? void 0 : _b.getTime());
    }, [created, edited]);
    var computeAccount = useMemo(function () {
        return API.toLang(account, language);
    }, [account, language]);
    return (React.createElement(CommentPostContainer, null,
        React.createElement(FlexBox, { direction: "column" },
            React.createElement(FlexBox, { width: '100%' },
                React.createElement(InfoAvatar, { href: window.location.origin + "/designer/".concat(accountId), target: "_blank" }, account && (React.createElement(Avatar
                // {...account} 
                , { 
                    // {...account} 
                    avatar: ProfileUtils.getAvatarURLOrUndefined(account), fs: 11, rounded: true }))),
                React.createElement(FlexBox, { gy: 6, direction: "column", directionMobile: "column" },
                    React.createElement(InfoTime, null,
                        formatDate(created !== null && created !== void 0 ? created : '', language),
                        "\u00A0",
                        hasEdited ? t('chat.post.edited') : ''),
                    React.createElement(InfoName, { href: window.location.origin + "/designer/".concat(accountId), target: "_blank" }, ProfileUtils.getFullNameString(computeAccount))))),
        profile && !tooltipProps.isChatClosed && (React.createElement(TooltipWrapper, null,
            React.createElement(CommentTools, __assign({ isEditable: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.isEditable(accountId), isDeletable: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.isDeletable(accountId), canAnswer: (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.canAnswer(accountId)) && !parentId, canReport: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.canReport(accountId), isBlackList: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.isBlackList, isWhiteList: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.isWhiteList, isPrivateChat: tooltipProps.isPrivateChat, isChatClosed: tooltipProps.isChatClosed, identifier: id }, handlers))))));
};
var CommentContent = function (_a) {
    var _b, _c;
    var post = _a.post;
    var t = useLocalization().t;
    if (post.status === POST_STATUS.deleted) {
        return React.createElement(DeletedMsg, null, t('chat.post.deleted'));
    }
    return (React.createElement(FlexBox, { direction: "column" },
        React.createElement(PostContentContainer, null,
            React.createElement(TextWithLinks, { text: post.text })),
        !!((_b = post === null || post === void 0 ? void 0 : post.attachments) === null || _b === void 0 ? void 0 : _b.length) && (React.createElement(ImagesWrapper, null,
            React.createElement(React.Fragment, null, (_c = post === null || post === void 0 ? void 0 : post.attachments) === null || _c === void 0 ? void 0 : _c.map(function (image) { return (React.createElement(CommentImages, { attachment: image, key: image.attachmentId })); }))))));
};
var CommentActions = function (_a) {
    var post = _a.post, tooltipProps = _a.tooltipProps, isLiked = _a.isLiked, likeCount = _a.likeCount, isEditing = _a.isEditing, handlers = _a.handlers;
    var t = useLocalization().t;
    var theme = useTheme();
    var currentId = useMemo(function () {
        return !!(post === null || post === void 0 ? void 0 : post.parentId) ? post.parentId : post.id;
    }, [post]);
    var canAnswer = useMemo(function () {
        return !!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.canAnswer(post.accountId)) && !(post === null || post === void 0 ? void 0 : post.parentId);
    }, [post, tooltipProps, isEditing]);
    if (post.status === POST_STATUS.deleted)
        return null;
    return (React.createElement(ActionsBlockContainer, { gx: 24 },
        React.createElement(LikesComponent, { isLiked: isLiked, disabled: !(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.canLike(post.accountId)), onLikeClick: function () {
                var _a;
                (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onLike) === null || _a === void 0 ? void 0 : _a.call(handlers, {
                    entityId: post.entityId,
                    entityType: post.entityType
                });
            } }),
        React.createElement(LikesCount, null, likeCount),
        canAnswer && (React.createElement("span", { onClick: function () {
                var _a;
                (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onAnswer) === null || _a === void 0 ? void 0 : _a.call(handlers, currentId !== null && currentId !== void 0 ? currentId : '');
            } }, t('chat.post.answer')))));
};
var Comment = function (_a) {
    var _b;
    var comment = _a.comment, tooltipProps = _a.tooltipProps, creatingId = _a.creatingId, handlers = _a.handlers, entityId = _a.entityId, postEntityId = _a.postEntityId;
    var t = useLocalization().t;
    var dispatch = useDispatch();
    var modal = useModal();
    var profile = useProfile();
    var newCommentRef = useRef(null);
    var auth = useAuth();
    var _c = useState(POST_STATUS.active), isDeleted = _c[0], setIsDeleted = _c[1];
    var _d = useState(false), isLiked = _d[0], setIsLiked = _d[1];
    var _e = useState(0), likeCount = _e[0], setLikeCount = _e[1];
    var _f = useState(null), isEditing = _f[0], setIsEditing = _f[1];
    useEffect(function () {
        setIsDeleted(comment.status);
        setIsLiked(comment.isQu);
        setLikeCount(comment.quCount || 0);
    }, [comment]);
    var handleClickOutside = function (event) {
        if (newCommentRef.current && !newCommentRef.current.contains(event.target)) {
            setIsEditing(null);
        }
    };
    useEffect(function () {
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    var getLocalHandlers = useCallback(function (comment) {
        return __assign(__assign({}, handlers), { onDelete: function (postId) {
                modal.show('templateModal', {
                    mainText: t('chat.modal.delete_title'),
                    confirmText: t('chat.modal.confirm_delete'),
                    secondText: t('chat.modal.delete_subtitle'),
                    cancelText: t('chat.modal.cancel'),
                    onConfirm: function () {
                        var _a;
                        handlers.onDelete((_a = (postId)) !== null && _a !== void 0 ? _a : '')
                            .then(function (response) {
                            if (response) {
                                setIsDeleted(POST_STATUS.deleted);
                                dispatch(updateCommentStatus({
                                    postEntityId: postEntityId,
                                    commentId: postId,
                                    parentId: comment === null || comment === void 0 ? void 0 : comment.parentId
                                }));
                                modal.hide();
                            }
                        });
                    },
                    onSecond: function () {
                        modal.hide();
                    }
                });
            }, onEdit: function (postId) {
                var _a;
                dispatch(onUpdateChatState({
                    answerId: postId,
                    imageMode: (comment === null || comment === void 0 ? void 0 : comment.attachments) && ((_a = comment === null || comment === void 0 ? void 0 : comment.attachments) === null || _a === void 0 ? void 0 : _a.length) > 0
                }));
                setIsEditing(COMMENT_EDIT_MODE.edit);
            }, onLike: function () {
                var _a, _b;
                if (comment && tooltipProps.canLike(comment.accountId)) {
                    if (!profile) {
                        auth.login();
                        return;
                    }
                    (_a = handlers.onLike) === null || _a === void 0 ? void 0 : _a.call(handlers, {
                        entityId: (_b = comment.id) !== null && _b !== void 0 ? _b : '',
                        entityType: 'comment'
                    }).then(function (response) {
                        var like = response;
                        setIsLiked(like.isLike);
                        setLikeCount(!!like.isLike ? likeCount + 1 :
                            (likeCount - 1));
                    });
                }
            }, onAnswer: function (id) {
                if (!profile) {
                    auth.login();
                    return;
                }
                dispatch(onUpdateChatState({ answerId: id, scrollId: null }));
                setIsEditing(COMMENT_EDIT_MODE.answer);
            } });
    }, [handlers, dispatch, likeCount, isEditing, tooltipProps]);
    var onUpdate = function () {
        setIsEditing(null);
    };
    var isSubComment = useMemo(function () {
        return (comment === null || comment === void 0 ? void 0 : comment.parentId) !== null;
    }, [isEditing, comment]);
    var newComment = useMemo(function () {
        if (isEditing === COMMENT_EDIT_MODE.answer) {
            return (React.createElement(NewCommentContainer, { ref: newCommentRef, width: '100%', widthMobile: '100%', offsetBottom: 32, offsetBottomMobile: 32 },
                React.createElement(CommentEdit, { entityId: comment === null || comment === void 0 ? void 0 : comment.entityId, postEntityId: postEntityId, chatAllowedProps: tooltipProps, mode: COMMENT_EDIT_MODE.answer, onUpdate: onUpdate })));
        }
    }, [tooltipProps, entityId, newCommentRef, isEditing, comment]);
    if (isDeleted) {
        return React.createElement(DeletedMsg, null, t('chat.post.deleted'));
    }
    if ((_b = [COMMENT_EDIT_MODE.edit]) === null || _b === void 0 ? void 0 : _b.includes(isEditing)) {
        return (React.createElement(CommentEdit, { entityId: comment === null || comment === void 0 ? void 0 : comment.entityId, postEntityId: postEntityId, mode: COMMENT_EDIT_MODE.edit, comment: comment, onUpdate: onUpdate }));
    }
    if ((comment === null || comment === void 0 ? void 0 : comment.id) === creatingId) {
        return (React.createElement(CommentItemContainer, { subComment: isSubComment, "data-message-id": comment.id },
            React.createElement(LoaderSpinner, { color: "#909090", text: t('chat.post.loading_text') })));
    }
    return (React.createElement(CommentItemContainer, { subComment: isSubComment, "data-message-id": comment.id },
        React.createElement(FlexBox
        // {...(isSubComment ? {
        //   offsetLeft: 32,
        //   offsetLeftMobile: 32,
        // } : {})}
        , { 
            // {...(isSubComment ? {
            //   offsetLeft: 32,
            //   offsetLeftMobile: 32,
            // } : {})}
            style: __assign({ gap: 16 }, (isSubComment ? {
                paddingRight: 0
            } : {})), width: '100%', widthMobile: '100%', direction: "column", directionMobile: "column" },
            React.createElement(CommentInfo, __assign({}, comment, { tooltipProps: tooltipProps }, getLocalHandlers(comment))),
            React.createElement(CommentContent, __assign({ post: comment }, handlers)),
            React.createElement(CommentActions, { post: comment, isLiked: isLiked, likeCount: likeCount, isEditing: isEditing, tooltipProps: tooltipProps, handlers: getLocalHandlers(comment) })),
        newComment));
};
export var CommentLoad = function (_a) {
    var data = _a.data, parentId = _a.parentId, postEntityId = _a.postEntityId, creatingId = _a.creatingId, onLoad = _a.onLoad, tooltipProps = _a.tooltipProps, handlers = _a.handlers;
    var t = useLocalization().t;
    var comments = useMemo(function () { return (data === null || data === void 0 ? void 0 : data.data) || []; }, [data]);
    var paging = useMemo(function () { return (data === null || data === void 0 ? void 0 : data.paging) || undefined; }, [data]);
    var _b = useState(false), showMore = _b[0], setShowMore = _b[1];
    var isCommentCreating = useMemo(function () {
        return comments === null || comments === void 0 ? void 0 : comments.some(function (comment) { return (comment === null || comment === void 0 ? void 0 : comment.id) === creatingId; });
    }, [comments, creatingId]);
    useEffect(function () {
        //to-do раскрывать ответы при добавлении нового ответа
        if (isCommentCreating) {
            setShowMore(true);
        }
    }, [isCommentCreating]);
    var needLoad = useMemo(
    //@ts-ignore
    function () { return (paging && (paging === null || paging === void 0 ? void 0 : paging.count) > SUB_COMMENT_OFFSET); }, [paging]);
    var isEndComment = useMemo(function () {
        return showMore && (comments === null || comments === void 0 ? void 0 : comments.length) === (paging === null || paging === void 0 ? void 0 : paging.count);
    }, [comments, paging, showMore]);
    var loadButton = useMemo(function () {
        if (isCommentCreating) {
            return React.createElement(Skeleton, { height: 20, width: 80 });
        }
        if (isEndComment) {
            return (React.createElement(CommentCount, { fs: 15, lh: 20, text: t('chat.hide_comments'), onClick: function () { return setShowMore(false); } }));
        }
        if (!needLoad)
            return;
        return (React.createElement(InfoTime, { onClick: onLoad, largeSize: true, style: { cursor: 'pointer', marginTop: 24 } }, t('chat.more')));
    }, [needLoad, paging, onLoad, showMore, , isCommentCreating, isEndComment]);
    var showAnswerButton = useMemo(function () {
        if ((paging === null || paging === void 0 ? void 0 : paging.count) === 0)
            return null;
        return (React.createElement(CommentCount, { count: paging === null || paging === void 0 ? void 0 : paging.count, text: t('chat.show_answers'), rotate: true, fs: 15, lg: 17, onClick: function () { return setShowMore(true); } }));
    }, [comments, paging]);
    if (paging.count > 0 && !showMore) {
        return showAnswerButton;
    }
    return (React.createElement(FlexBox, { gy: 32, gyMobile: 32, offsetLeft: 32, direction: "column", directionMobile: "column" }, comments === null || comments === void 0 ? void 0 :
        comments.map(function (post) {
            var _a;
            return (React.createElement("div", { key: (_a = post.id) !== null && _a !== void 0 ? _a : '' },
                React.createElement(Comment, { comment: post, tooltipProps: tooltipProps, handlers: handlers, creatingId: creatingId, postEntityId: postEntityId })));
        }),
        loadButton));
};
var CommentPost = function (_a) {
    var entityId = _a.entityId, comment = _a.comment, creatingId = _a.creatingId, order = _a.order, postHidden = _a.postHidden, handlers = _a.handlers, postEntityId = _a.postEntityId, tooltipProps = _a.tooltipProps;
    var comments = comment.comments, commentsCount = comment.commentsCount, loading = comment.loading;
    var profile = useProfile();
    var dispatch = useDispatch();
    var isModer = useMemo(function () { return profile && (bProfile.isModer(profile)); }, [profile]);
    var channelOwner = tooltipProps.channelOwner, isBlackList = tooltipProps.isBlackList, isWhiteList = tooltipProps.isWhiteList, isPrivateChat = tooltipProps.isPrivateChat, isChatClosed = tooltipProps.isChatClosed, isChatPause = tooltipProps.isChatPause;
    var isChannelOwner = useMemo(function () {
        return (channelOwner === null || channelOwner === void 0 ? void 0 : channelOwner.accountId) === (profile === null || profile === void 0 ? void 0 : profile.accountId);
    }, [profile, tooltipProps, channelOwner]);
    var canAnswer = useCallback(function (ownerId) {
        if (isChatClosed || isChatPause || isBlackList)
            return false;
        else if (isPrivateChat && !isWhiteList)
            return false;
        return true;
    }, [
        profile,
        tooltipProps,
        isWhiteList,
        isChatClosed,
        isBlackList
    ]);
    var isEditable = useCallback(function (ownerId) {
        return ownerId === (profile === null || profile === void 0 ? void 0 : profile.accountId) && !tooltipProps.isChatClosed;
    }, [profile, tooltipProps]);
    var isDeletable = useCallback(function (ownerId) {
        return ownerId === (profile === null || profile === void 0 ? void 0 : profile.accountId) || isChannelOwner || isModer;
    }, [profile, tooltipProps]);
    var canReport = useCallback(function (ownerId) {
        return ownerId !== (profile === null || profile === void 0 ? void 0 : profile.accountId);
    }, [profile, tooltipProps]);
    var canLike = useCallback(function (ownerId) {
        if (isBlackList || isChatPause || isChatClosed || !profile)
            return false;
        else if (isPrivateChat && !isWhiteList)
            return false;
        return true;
    }, [
        profile,
        tooltipProps,
        isChatPause,
        isChatClosed,
        isWhiteList,
        isPrivateChat,
        isBlackList
    ]);
    var fetchMore = function () {
        var _a;
        if (comments && comment) {
            dispatch(fetchMoreTreeComments({
                entityId: comment.entityId,
                parentId: comment.id,
                entityType: comment.entityType,
                postEntityId: postEntityId,
                parentFilter: {
                    //@ts-ignore
                    page: ((_a = comments === null || comments === void 0 ? void 0 : comments.paging) === null || _a === void 0 ? void 0 : _a.page) + 1,
                    offset: (comments === null || comments === void 0 ? void 0 : comments.paging.offset) + SUB_COMMENT_OFFSET,
                    limit: SUB_COMMENT_OFFSET
                }
            }));
        }
    };
    var localTooltipProps = useMemo(function () {
        return __assign(__assign({}, tooltipProps), { canAnswer: canAnswer, canReport: canReport, canLike: canLike, isEditable: isEditable, isDeletable: isDeletable });
    }, [
        tooltipProps,
        canReport,
        canAnswer,
        canLike,
    ]);
    var postComments = useMemo(function () {
        var _a, _b;
        if (commentsCount === 0 || comment.status === POST_STATUS.deleted)
            return null;
        if ((_a = comments === null || comments === void 0 ? void 0 : comments.data) === null || _a === void 0 ? void 0 : _a.length) {
            return React.createElement(CommentLoad, { data: comments, postEntityId: postEntityId, onLoad: fetchMore, parentId: (_b = comment.id) !== null && _b !== void 0 ? _b : '', creatingId: creatingId, tooltipProps: localTooltipProps, handlers: handlers });
        }
        return null;
    }, [comments, handlers, creatingId, comment, postEntityId, commentsCount]);
    if (postHidden)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(CommentItemContainer, { isMainComment: true, "data-message-id": comment.id, className: 'comment-item-container' },
            React.createElement(Comment, { comment: comment, tooltipProps: localTooltipProps, postEntityId: postEntityId, handlers: handlers, creatingId: creatingId }),
            postComments)));
};
export default CommentPost;
//# sourceMappingURL=CommentPost.js.map